import React from 'react';
import teamData from '../data/equipo';
import { GraduationCap, Award, Heart } from 'lucide-react';
import './Team.css';

const Team = () => {
    return (
        <div className="team-page">
            <div className="team-header">
                <h1>Nuestro Equipo</h1>
                <p>Profesionales apasionados por tu salud y bienestar.</p>
            </div>

            <div className="container">
                <div className="team-list">
                    {teamData.map((member, index) => (
                        <div
                            key={member.id}
                            className={`member-row ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
                        >
                            <div className="member-photo-container">
                                <div className="photo-frame">
                                    {member.imagen
                                    ? <img src={require(`../images/${member.imagen}`)} alt={member.name} />
                                    : <div className="photo-placeholder" />
                                }
                                </div>
                                <div className="decorative-pattern">
                                    <div className="pattern-circle"></div>
                                    <div className="pattern-circle"></div>
                                    <div className="pattern-circle"></div>
                                </div>
                            </div>

                            <div className="member-content">
                                <div className="member-header">
                                    <h2>{member.name}</h2>
                                    <div className="member-credentials">
                                        <div className="credential">
                                            <GraduationCap size={18} />
                                            <span>{member.estudio1}</span>
                                        </div>
                                        {member.estudio2 && (
                                            <div className="credential">
                                                <Award size={18} />
                                                <span>{member.estudio2}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="member-bio">
                                    <div className="bio-section">
                                        <p>{member.descripcionp1}</p>
                                    </div>
                                    {member.descripcionp2 && (
                                        <div className="bio-section">
                                            <p>{member.descripcionp2}</p>
                                        </div>
                                    )}
                                </div>

                                <div className="member-footer">
                                    <Heart size={16} className="heart-icon" />
                                    <span>Comprometido con tu bienestar</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Team;
